module.exports = __webpack_public_path__ + "img/image 10.46f52c22.png";